import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../constants/endpoints";
import { toast } from "react-toastify";
import api from "../../services/instance";

export const ResetPasswordAPI = createAsyncThunk(
    'ResetPasswordAPI',
    async (data) => {
        try {
            const response = await api.post(endpoints.resetPassword(), data);
            return response;
        } catch (error) {
            throw error;
        }
    }
)


const initialState = {
    loading: false
}

export const ResetPasswordSlice = createSlice({
    initialState,
    name: "ResetPasswordSlice",
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(ResetPasswordAPI.pending, (state, action) => {
            state.loading = true

        })

        builder.addCase(ResetPasswordAPI.fulfilled, (state, action) => {
            state.loading = false
            toast.success(action.payload.data.message)
        })

        builder.addCase(ResetPasswordAPI.rejected, (state, action) => {
            state.loading = false
            toast.error(action.payload.data.message)
        })
    }
})

export const { } = ResetPasswordSlice.actions
export default ResetPasswordSlice.reducer